/**
 * Base Node parser - minimal parsing for hierarchy tracking.
 */
import { parseOptionalTransform } from '../../utils/transform';
import { parseHeadingIndex } from '../../parser/valueParsers';
export function parseNode(heading, properties) {
    const name = heading.attributes.name || '';
    const parent = heading.attributes.parent;
    const instance = heading.attributes.instance;
    const index = parseHeadingIndex(heading.attributes.index);
    const transform = parseOptionalTransform(properties.transform, name);
    return {
        name,
        parent,
        instance,
        index,
        transform,
    };
}
//# sourceMappingURL=parser.js.map